import React from 'react';
import { connect } from 'react-redux';

export function TestErrorsUnconnected({ globalError }) {
  if (!globalError) {
    return null;
  }

  return (
    <div className="error">
      {globalError}
    </div>
  );
}

const mapStateToProps = state => ({ globalError: state.rteTest.globalError });

export default connect(mapStateToProps)(TestErrorsUnconnected);
